import {  inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { selectIsLoggedIn } from '@store/selectors/user/user.selectors';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

export const userLoadedResolver: ResolveFn<boolean> = (route, state) => {
  return inject(Store).select(selectIsLoggedIn).pipe(
      filter((data) => {
          return data;
      })
  );
};
